import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fe97462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = { class: "step-number" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step-description" }, "ENTER SIZE DETAILS", -1))
const _hoisted_4 = {
  key: 0,
  class: "size-chart"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "items" }
const _hoisted_7 = { class: "row custom-row-padding" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "col-md-2 qty" }
const _hoisted_11 = ["for"]
const _hoisted_12 = ["id", "onUpdate:modelValue", "onInput"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-times",
  style: {"font-size":"1rem"}
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = { class: "add-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.chartRequired ? 'chart-tab-header' : 'tab-header'])
    }, [
      _createElementVNode("span", _hoisted_2, "STEP " + _toDisplayString(_ctx.activeSidebarOption ? _ctx.activeSidebarOption.stepNumber : ""), 1),
      _hoisted_3
    ], 2),
    (_ctx.chartRequired && _ctx.sizingPdfUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("a", {
            href: `${_ctx.sizingPdfUrl}`,
            target: "_blank"
          }, "Size chart guide", 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_TransitionGroup, {
        name: "list",
        tag: "div"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizesDetails, (el, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "product-item",
              key: el.id
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", {
                    for: `size${index}`
                  }, "SELECT SIZE", 8, _hoisted_9),
                  _createVNode(_component_Dropdown, {
                    id: `size${index}`,
                    modelValue: el.size,
                    "onUpdate:modelValue": ($event: any) => ((el.size) = $event),
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDataChange())),
                    options: _ctx.sizeOptions,
                    placeholder: "Choose size",
                    optionLabel: "name"
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", {
                    for: `quantity-input${index}`
                  }, "QTY", 8, _hoisted_11),
                  _withDirectives(_createElementVNode("input", {
                    min: "1",
                    type: "number",
                    id: `quantity-input${index}`,
                    "onUpdate:modelValue": ($event: any) => ((el.quantity) = $event),
                    onInput: ($event: any) => (_ctx.quantityChanged(index))
                  }, null, 40, _hoisted_12), [
                    [_vModelText, el.quantity]
                  ])
                ]),
                _createElementVNode("div", {
                  class: "col-md-2 remove-button",
                  onClick: ($event: any) => (_ctx.removePlayer(index))
                }, _hoisted_15, 8, _hoisted_13)
              ]),
              _hoisted_16
            ]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_Button, {
          onClick: _ctx.addNewPlayer,
          label: "ADD SIZE"
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}